<h5>New Locations</h5>

@if (!loading && patientInteractionLocations.length > 0) {
  <p class="fst-italic">
    NOTE: Data from locations in this list will not be used to capture claims until a review is completed.
  </p>
}

@if (!loading) {
  @if (patientInteractionLocations.length > 0) {
    <app-pagination-header
      [label]="'locations to review'"
      [paging]="paging"
      (pageSizeChange)="onPageSizeChange($event)" />
    <app-patient-interaction-location-list
      [includeClientColumn]="false"
      [patientInteractionLocations]="patientInteractionLocations" />
    <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
  } @else {
    No new locations. All locations have been reviewed.
  }
} @else {
  <mat-spinner diameter="30" />
}


